import { InputNames, ErrorText } from "../features/error/validation-slice";

//メールアドレスのパターン　正規表現
export const emailAddressPattern =
  /^[a-zA-Z0-9_-]+([a-zA-Z0-9_.-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
// メールアドレスに使える文字種のパターン　正規表現
export const emailCharPattern = /^[a-zA-Z0-9_.@-]+$/;
//半角数値のパターン 正規表現
export const halfNumberPattern = /^[0-9]+$/;
//半角英数字のチェック
export const halfCharPattern = /^[0-9a-zA-Z]+$/;
//半角数値(小数点を含む)のパターン(整数値2桁,小数点第2位) 正規表現
export const halfNumberDecimalPattern1 = /^([0-9]{1,2})(\.\d{1,2})?$/;
//半角数値(小数点を含む)のパターン(整数値3桁,小数点第2位) 正規表現
export const halfNumberDecimalPattern2 = /^([0-9]{1,3})(\.\d{1,2})?$/;
//カタカナのパターン 正規表現
export const katakanaPattern = /^[\u30A0-\u30FF]+$/;
//全銀テレ使用禁止文字
export const katakanaDoNotUsePattern = /^[ァヰヱィッャゥュヵェヶョォヮ]+$/;
//半角大文字英数字
export const halfEnglishCharPattern = /^[0-9A-Z]+$/;
//全角大文字英数字
export const fullEnglishCharPattern = /^[０-９Ａ-Ｚ]+$/;
//半角記号
export const halfMarkPattern = /^[,./\-() ]+$/;
//全角記号
export const fullMarkPattern = /^[，．ー／（）￥　]+$/;

/**
 * メアドの正規表現チェック
 * @param mail メールアドレス文字列
 * @returns チェック結果OKの場合true
 */
export const isMailValid = (mail: string) => {
  if (mail !== "" && !emailAddressPattern.test(mail)) {
    return false;
  }
  return true;
};

/**
 * メアドの文字種のチェック
 * @param mail メールアドレス文字列
 * @returns チェック結果OKの場合true
 */
export const isMailCharValid = (mail: string) => {
  if (mail !== "" && !emailCharPattern.test(mail)) {
    return false;
  }
  return true;
};

/**
 * 必須チェック
 * @param input チェック対象文字列
 * @returns チェック結果OKの場合true
 */
export const isNull = (input: string) => {
  if (input === null || input.trim() === "") {
    return true;
  }
  return false;
};

/**
 * 文字数チェック
 * @param input チェック対象文字列
 * @param inputLength 文字数上限
 * @returns チェック結果OKの場合true
 */
export const isLengthValid = (input: string, inputLength: number) => {
  if (input.length > inputLength) {
    return false;
  }
  return true;
};

/**
 * 半角数値チェック
 * @param input チェック対象文字列
 * @returns チェック結果OKの場合true
 */
export const isHalfNumberValid = (input: string) => {
  if (input !== "" && !halfNumberPattern.test(input)) {
    return false;
  }
  return true;
};

/**
 * 半角英数値チェック
 * @param input チェック対象文字列
 * @returns チェック結果OKの場合true
 */
export const isHalfNumberAndCharValid = (input: string) => {
  if (input !== "" && !halfCharPattern.test(input)) {
    return false;
  }
  return true;
};

/**
 * 半角数値(小数点を含む)チェック 整数値2桁、小数第2位
 * @param input チェック対象文字列
 * @returns チェック結果OKの場合true
 */
export const isHalfNumberDecimalValid1 = (input: string) => {
  if (input !== "" && !halfNumberDecimalPattern1.test(input)) {
    return false;
  }
  return true;
};

/**
 * 半角数値(小数点を含む)チェック 整数値3桁、小数第2位
 * @param input チェック対象文字列
 * @returns チェック結果OKの場合true
 */
export const isHalfNumberDecimalValid2 = (input: string) => {
  if (input !== "" && !halfNumberDecimalPattern2.test(input)) {
    return false;
  }
  return true;
};

/**
 * カタカナチェック
 * @param input チェック対象文字列
 * @returns チェック結果OKの場合true
 */
export const isKatakanaValid = (input: string) => {
  if (input !== "" && !katakanaPattern.test(input)) {
    return false;
  }
  return true;
};

/**
 * 全銀テレ使用文字チェック
 * @param input チェック対象文字列
 * @returns チェック結果OKの場合true
 */
export const isKatakanaFullCharPattern = (input: string) => {
  if (input === "") {
    return true;
  }
  for (let char of input) {
    const isKatakanaValid =
      katakanaPattern.test(char) && !katakanaDoNotUsePattern.test(char);
    const isHalfEnglishValid = halfEnglishCharPattern.test(char);
    const isFullEnglishValid = fullEnglishCharPattern.test(char);
    const isHalfMarkValid = halfMarkPattern.test(char);
    const isFullMarkValid = fullMarkPattern.test(char);
    if (
      !isKatakanaValid &&
      !isHalfEnglishValid &&
      !isFullEnglishValid &&
      !isHalfMarkValid &&
      !isFullMarkValid
    ) {
      return false;
    }
  }
  return true;
};

/**
 * 文字数固定値チェック
 * @param input チェック対象文字列
 * @param inputLength 固定文字数
 * @returns チェック結果OKの場合true
 */
export const isLengthFixedValid = (input: string, inputLength: number) => {
  if (input !== "" && input.length !== inputLength) {
    return false;
  }
  return true;
};

/**
 * 半角数値固定値チェック
 * @param input チェック対象文字列
 * @param inputLength 固定文字数
 * @returns チェック結果OKの場合true
 */
export const isHalfNumberLengthValid = (input: string, inputLength: number) => {
  if (
    input === "" ||
    !halfNumberPattern.test(input) ||
    input.length !== inputLength
  ) {
    return false;
  }
  return true;
};

/**
 * パスワードポリシーチェック
 * @param input チェック対象文字列
 * @returns チェック結果OKの場合true
 */
export const isPasswordPolicyValid = (input: string) => {
  const minLength = 12;
  const patternStr = "^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[ -/:-@[-`{-~]).*$";
  const pattern = new RegExp(patternStr, "g");
  return input.length >= minLength && pattern.test(input);
};

/**
 * エラーメッセージ取得
 * @param name チェック項目名
 * @param formErrTxts すべてのInputエラーメッセージ
 * @returns 当該項目のエラーメッセージ
 */
export const getErrorText = (
  name: keyof InputNames,
  formErrTxts: ErrorText[]
) => {
  return formErrTxts.find((txt) => txt.inputName === name)?.msg;
};

interface Code {
  value: string;
  label: string;
}
/**
 * コード値存在チェック
 * @param items ターゲットコードリスト
 * @param targetValue ターゲットコード値
 * @returns リストにある場合にTrue
 */
export const hasItem = (items: Code[], targetValue: string) => {
  return items.some((item) => item.value === targetValue);
};

/**
 * 半角数値リストチェック
 * @param input チェック対象文字列
 * @param delimiter 区切り文字
 * @returns チェック結果OKの場合true
 */
export const isHalfNumberListValid = (input: string, delimiter: string) => {
  const halfNumberListPattern = listRegExp(halfNumberPattern, delimiter);
  return input === "" || halfNumberListPattern.test(input);
};

/**
 * 半角英数字リストチェック
 * @param input チェック対象文字列
 * @param delimiter 区切り文字
 * @returns チェック結果OKの場合true
 */
export const isHalfCharListValid = (input: string, delimiter: string) => {
  const halfCharListPattern = listRegExp(halfCharPattern, delimiter);
  return input === "" || halfCharListPattern.test(input);
};

/**
 * 区切り文字で区切った文字列で表現されたリストに対する正規表現作成
 * @param itemRegExp リスト要素の正規表現
 * @param delimiter 区切り文字
 * @returns リストを区切り文字で区切った文字列の正規表現
 */
const listRegExp = (itemRegExp: RegExp, delimiter: string) => {
  const itemRegExpStr = itemRegExp.source.replace(/(\^|\$)/g, "");
  const listRegExpStr = `^(?:${itemRegExpStr})(?:${delimiter}${itemRegExpStr})*$`;
  return new RegExp(listRegExpStr);
};
